import loadable from '@loadable/component';

export const ThSiteWrapper = loadable(
  () => import(/* webpackChunkName: "th-site" */ './ThSiteWrapper'),
);
